import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=23548936&scoped=true"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=23548936&prod&scoped=true&lang=css"
import style1 from "./EditEvent.vue?vue&type=style&index=1&id=23548936&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23548936",
  null
  
)

export default component.exports